import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Loader2, Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import api, { apiError } from "../lib/api";
import { useSeo } from "../lib/useSeo";

export default function BlogSubscriptionPage() {
  const location = useLocation();
  const action = location.pathname.endsWith("unsubscribe") ? "unsubscribe" : "confirm";
  const token = new URLSearchParams(location.hash.slice(1)).get("token") || "";
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  useSeo({ title: "Blog email preferences", noindex: true });
  const submit = async () => {
    setBusy(true); setError("");
    try {
      const response = await api.post(`/blog-updates/${action}`, { token });
      setMessage(response.data.message);
      window.history.replaceState(null, "", location.pathname);
    } catch (e) { setError(apiError(e)); }
    finally { setBusy(false); }
  };
  return <div className="max-w-xl mx-auto px-4 py-16 min-h-[60vh]" data-testid="blog-subscription-page">
    {message ? <CheckCircle2 size={32} className="text-emerald-700 mb-5" /> : <Mail size={32} className="text-emerald-700 mb-5" />}
    <h1 data-testid="blog-subscription-title" className="font-display text-3xl font-bold">{message ? "Email preferences updated" : action === "confirm" ? "Confirm your blog updates" : "Unsubscribe from blog updates"}</h1>
    {message ? <p role="status" data-testid="blog-subscription-success" className="mt-5 text-emerald-800">{message}</p> : <>
      <p className="mt-4 text-sm text-slate-600" data-testid="blog-subscription-description">{action === "confirm" ? "Receive an email whenever a new XpressPrompts blog is published." : "Stop blog update emails. Your membership and account emails won't change."}</p>
      {token ? <Button onClick={submit} disabled={busy} data-testid="blog-subscription-confirm" className="mt-6 bg-emerald-800 hover:bg-emerald-900 gap-2">{busy && <Loader2 size={16} className="animate-spin" />}{busy ? "Updating…" : action === "confirm" ? "Confirm subscription" : "Unsubscribe"}</Button> : <p role="alert" data-testid="blog-subscription-missing-token" className="mt-5 text-red-700">This link is incomplete. Please open the full link from your email.</p>}
    </>}
    {error && <p role="alert" data-testid="blog-subscription-error" className="mt-4 text-red-700">{error}</p>}
    <Link to="/blog" data-testid="blog-subscription-back" className="inline-block mt-8 text-sm text-emerald-800 underline">Back to XpressPrompts Blogs</Link>
  </div>;
}